import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: 'What is a graphical abstract maker?',
          answer:
            'Graphical abstract maker is a tool that automatically transform your abstract into a beautiful and useful infographic. An AI system that improves your research in just a few minutes.',
        },
        {
          question: 'Why do you need a graphical abstract?',
          answer:
            'Having a graphical abstract in your research paper is a way of making it much more attractive. A study performed by Cactus Communications shows that articles with Graphical Abstracts have: 8x more shares on social media, 15x more citations and are 27x more often cited.',
        },
        {
          question: 'How to make a good graphical abstract?',
          answer:
            'To create a good Graphical Abstract you’ll need science accurate illustrations, beautiful color palettes and useful elements to compose your design. You can find these and much more in Graphical Abstract Maker.',
        },
      ]}
    />
  );
}
